import { moveStickyInnerComponent, moveStickyWebComponent } from '../../components-helpers/components-helpers';

/**
 * Build redirection URL for compare feature
 */
export const redirectionBuilder = (
  compareStorageValues: Array<string>,
  country: string,
  language: string,
  redirectionBaseUrl: string
): string => {
    const idsConnectionString = '%7C';
    const idsUrlPartial = compareStorageValues?.join(idsConnectionString);
    const localeString = `/${country}/${language}/`;
    const subPathForcomparison = 'product-comparator/jorpn/';
    const urlPath = localeString + subPathForcomparison + idsUrlPartial;
    const urlOrigin = new URL(window.location.href).origin;
    const redirectionUrl = getCurrentUrlOrigin(redirectionBaseUrl || urlOrigin);

    redirectionUrl.pathname = urlPath;

    return redirectionUrl.href;
};

/**
 * Create object URL
 */
export const getCurrentUrlOrigin = (url: string): URL => new URL(url);

/**
 * Calculate position for absolute or sticky positioned items
 */
export const calculatedStickyItemsPosition = (
  element: HTMLElement,
  breakpoint: boolean,
): {
  accessibilityBottomValueWithCompare: number;
  scrollToTopBottomValueWithCompare: number;
} => {
    const accessibilityBottomValueWithCompare = calculateHeight(element, breakpoint) - 20;
    const scrollToTopBottomValueWithCompare = calculateHeight(element, breakpoint);

    return {
      accessibilityBottomValueWithCompare,
      scrollToTopBottomValueWithCompare,
    };
};

/**
 * Calculate height of compare bar for
 * Moveable absolute or sticky positioned items
 */
export const calculateHeight = (element: HTMLElement, breakpoint: boolean) => {
    const elementToGetHeight = breakpoint ? '.compare-wrapper-bar' : '.compare-wrapper';

    return element.shadowRoot?.querySelector<HTMLElement>(elementToGetHeight)?.offsetHeight;
};

/**
 * Check breakpoint optional parameter
 * for moveStickyItem but only before mobile view
 */
const isBreakpointPassed = (breakpoint: number, isMobileView: boolean) => {
    if (!breakpoint || isMobileView) return false;
    if (window.innerWidth <= breakpoint) {
      return true;
    } else return false;
};

/**
 * Move absolute or sticky postioned items
 * Depending on operation (visible or hidden compare bar)
 */
export const moveStickyItem = (
  element: HTMLElement,
  compareStorageValuesLength: number,
  isMobileView: boolean,
  breakpoint?: number,
  offset?: number,
  scrollTopBottomValue?: number
) => {
    const initialAccessibilityBottomValue = -6;
    const initialScrollToTopBottomValue = scrollTopBottomValue || 11;
    const accessibilityComponentName = 'uiaas-search-accessibility-toggle';
    const scrollToTopComponentName = 'svs-scroll-to-top-button';


    if (compareStorageValuesLength && (isMobileView || isBreakpointPassed(breakpoint, isMobileView))) {
      const calculatedPositions = calculatedStickyItemsPosition(element, isBreakpointPassed(breakpoint, isMobileView));

      moveStickyWebComponent(
        'uiaas-search-accessibility-toggle',
        'bottom',
        calculatedPositions.accessibilityBottomValueWithCompare + (offset || 0)
      );

      moveStickyInnerComponent(
        'uiaas-search',
        'svs-scroll-to-top-button',
        'bottom',
        calculatedPositions.scrollToTopBottomValueWithCompare + (offset || 0)
      );
    } else {
      moveStickyWebComponent(
        accessibilityComponentName,
        'bottom',
        initialAccessibilityBottomValue
      );

      moveStickyInnerComponent(
        'uiaas-search',
        scrollToTopComponentName,
        'bottom',
        initialScrollToTopBottomValue
      );
    }
};

/**
 * Gets clicked inner host element
 * from emitted event
 */
export const clickedElement = (e) => [
  ...e.composedPath()?.filter(
    (el) => el?.dataset?.compareArea
  ) ?? []
]?.[0]?.dataset?.compareArea;
